import { LocalDate } from '@js-joda/core';

import { FormContextValues } from '@dreryk/react-common';
import { DatePicker, dayValidator } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../../translations';

const t = patientMedicalInformationTranslationKeys.chronicDisease.form.create;

const DIAGNOSIS_REMOVAL_DATE_FIELD_NAME = 'diagnosisRemovalDate';

type DiagnosisRemovalDateType = LocalDate | null;

export type DiagnosisRemovalDateFormBeanPart = { [DIAGNOSIS_REMOVAL_DATE_FIELD_NAME]: DiagnosisRemovalDateType };
type RemovalDatePickerProps = Pick<FormContextValues<DiagnosisRemovalDateFormBeanPart>, 'register' | 'watch'>;

export const RemovalDatePicker = (props: RemovalDatePickerProps): JSX.Element => {
   const selectedCreationDate = props.watch<'diagnosisCreationDate', LocalDate | undefined>('diagnosisCreationDate');

   return (
      <DatePicker
         testId={DIAGNOSIS_REMOVAL_DATE_FIELD_NAME}
         controller={props.register(DIAGNOSIS_REMOVAL_DATE_FIELD_NAME)}
         label={t.diagnosisRemovalDate.label}
         dayValidators={[
            dayValidator.dayAfterToday(),
            dayValidator.dayBeforeReferenceDay(
               selectedCreationDate,
               t.diagnosisRemovalDate.validate.cannotBeBeforeCreationDate
            ),
         ]}
         withNavigationArrows
      />
   );
};
